// Cookiebot domain group ID per brand. Leave empty until the brand's domain is set up in Cookiebot -
// locales without an ID don't load the banner and keep loading analytics as before
export const CookiebotID = {
    dk: '563ff310-a4be-4004-8275-d86c9af65baf',
    se: '5527dc8d-775d-4bdf-9051-7d58ae08dadc',
    no: '5527dc8d-775d-4bdf-9051-7d58ae08dadc',
    da: '5527dc8d-775d-4bdf-9051-7d58ae08dadc'
}

// Language of the Cookiebot banner per brand
export const CookiebotCulture = {
    dk: 'DA',
    se: 'SV',
    no: 'NB',
    da: 'DA'
}
